"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = (isMobileDevice) => {
    const setStyles = {
        root: {
            display: "flex!important",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "transparent",
            borderRadius: "7px",
            color: "#344054",
            cursor: "pointer",
            height: "40px",
            width: "40px",
            marginLeft: isMobileDevice ? 5 : "none",
            marginRight: isMobileDevice ? 5 : "none",
            outline: "none",
            transitionDuration: ".15s",
            transitionProperty: "color, background-color, border",
            transitionTimingFunction: "linear",
            border: "1px solid #D0D5DD",
            boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
            padding: "0.375rem",
            // Disabled button appearance
            "&:disabled": {
                color: "#ff6565",
                opacity: 0.5,
                cursor: "not-allowed",
            },
            "&.custom": {
                backgroundColor: "transparent",
            },
            // Active button appearance states
            "&.video-button--on": {
                color: "#344054",
            },
            "&.video-button--off": {
                color: "#ff6565",
            },
            "&.video-button--active": {
                backgroundColor: "#ff6565",
                color: "#344054",
            },
            "&.video-button--get-sound": {
                position: "absolute",
                zIndex: 130,
                left: 0,
            },
            // Button flex position helper
            "&.video-push-left": {
                marginLeft: "auto",
            },
            "&.video-push-right": {
                marginRight: "auto",
            },
            // lv styles
            // Active button appearance states
            "&.lv-button--on": {
                color: "#344054",
            },
            "&.lv-button--off": {
                color: "#ff6565",
            },
            "&.lv-button--active": {
                backgroundColor: "#ff6565",
                color: "#344054",
            },
            "&.lv-button--get-sound": {
                position: "absolute",
                zIndex: 130,
                left: 0,
            },
            // Button flex position helper
            "&.lv-push-left": {
                marginLeft: "auto",
            },
            "&.lv-push-right": {
                marginRight: "auto",
            },
        },
    };
    return setStyles;
};
exports.default = styles;
//# sourceMappingURL=styles.js.map